import { SITE_URL } from "@/lib/founders/content";

export const POSTS_PER_PAGE = 12;
export const BLOG_NAME = "Crayo Blog";
export const BLOG_DEFAULT_IMAGE = "https://crayo-ai.ghost.io/content/images/2025/02/crayo.jpg";

export const blogPagePath = (page: number) => (page > 1 ? `/blog/page/${page}` : "/blog");

export const topicPath = (slug: string, page = 1) =>
  page > 1 ? `/blog/tag/${slug}/page/${page}` : `/blog/tag/${slug}`;

export const authorPath = (slug: string, page = 1) =>
  page > 1 ? `/blog/author/${slug}/page/${page}` : `/blog/author/${slug}`;

export const postPath = (slug: string) => `/blog/${slug}`;

export const absoluteBlogUrl = (path: string) => `${SITE_URL}${path}`;
